module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4ggCExEz/0jMTAAAAGpJREFUKM/tkkENgEAMBCfkDGABC1g4LWcBC2jAAhJAC1aGz/EhuSOB8CHMp4+m2027UEDt1UUdqRAqvRaIXNDwkA8IBDXlg53pjqoOhfmZ/Kq7xADMwFpwkIANmAoONipBinnL8ufgZYEdFR9gs6pqAD4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonSquare/assets/img/cross_button_icon.png
// module id = 555
// module chunks = 168707334958949